import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MarketplaceAnalyticsContext } from '@atlassian/mpac-analytics';
import { makeUserId } from '@atlassian/mpac-types';
import { ErrorBoundary } from '@atlassian/mpac-ui';
import { getSentryClient, initSentry } from '@atlassian/mpac-utils';
import React, { useEffect, useMemo } from 'react';
import version from '../../../../version';
import AnalyticsClient from '../../analytics/Client';
import { initializeBackends } from '../../analytics/Send';
import { initSPI } from '../../services/SPI';
import { useCurrentUser } from '../AppInstallDialog/hooks/useCurrentUser';
import { useHostData } from '../AppInstallDialog/hooks/useHostData';
import { useLinkTemplates } from '../AppInstallDialog/hooks/useLinkTemplates';
import { AppRequestDialogModal } from './AppRequestDialogModal';
import { AppRequestDialogModalError } from './AppRequestDialogModal/AppRequestDialogModalError';
import { useAppRequestAnalytics } from './hooks/useAppRequestAnalytics';
import { useAppRequestBaseData } from './hooks/useAppRequestBaseData';
export function AppRequestDialog(props) {
  useMemo(() => initSPI(props.spi), [props.spi]);
  const {
    hostInfo,
    hostConfig
  } = useHostData();
  const currentUser = useCurrentUser();
  const appRequestBaseData = useAppRequestBaseData(props.config, hostInfo, currentUser, props.appKey);
  const {
    fireEvent,
    analyticsContext
  } = useAppRequestAnalytics({
    baseData: appRequestBaseData,
    requestLocation: props.requestLocation
  });
  const links = useLinkTemplates({
    adminHubBaseUrl: props.config.adminHubBaseUrl,
    mpacBaseUrl: props.config.mpacBaseUrl,
    mpacCdnBaseUrl: props.config.mpacCdnBaseUrl,
    macBaseUrl: props.config.macBaseUrl,
    wacBaseUrl: props.config.wacBaseUrl,
    atlassianCommunityBaseUrl: props.config.atlassianCommunityBaseUrl
  });
  useEffect(() => {
    if (hostInfo && currentUser !== null && currentUser !== void 0 && currentUser.atlassianAccountId) {
      AnalyticsClient.init(props.config, hostConfig, hostInfo);
      initializeBackends(hostInfo, makeUserId(currentUser.atlassianAccountId));
    }
  }, [hostInfo, currentUser]);
  return /*#__PURE__*/React.createElement(MarketplaceAnalyticsContext, analyticsContext, /*#__PURE__*/React.createElement(AppRequestDialogModal, _extends({}, props, {
    hostInfo: hostInfo,
    hostConfig: hostConfig,
    links: links,
    currentUser: currentUser,
    appRequestBaseData: appRequestBaseData,
    fireEvent: fireEvent
  })));
}
export default function AppRequestDialogContainer(props) {
  var _getSentryClient;
  const appConfig = props.config;
  const sentryConfig = appConfig.sentryConfig;
  const isDev = appConfig.environment === 'local' || appConfig.environment === 'dev';
  const releaseVersion = "EMCEE_NATIVE_".concat(version).concat(isDev ? '-dev' : '');
  initSentry(_objectSpread(_objectSpread({}, sentryConfig), {}, {
    releaseVersion,
    setupGlobalListeners: false
  }));
  (_getSentryClient = getSentryClient()) === null || _getSentryClient === void 0 ? void 0 : _getSentryClient.setTag('requestLocation', props.requestLocation);
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    boundaryName: "marketplaceAppRequestDialog",
    fallback: /*#__PURE__*/React.createElement(AppRequestDialogModalError, {
      onClose: props.onClose
    })
  }, /*#__PURE__*/React.createElement(AppRequestDialog, props));
}